<div *ngIf="admin && adminStatus">
  <div class="row mt-4 bg-light p-1 mr-2 ml-2">
    <div class="col-lg-2 col-md-2 col-sm-4 col-4 text-center align-middle">
      <img *ngIf="admin.image" class="logo-5 rounded-circle" src="{{admin.image}}" alt="{{admin.name}}" />
      <img *ngIf="!admin.image" class="logo-5 rounded-circle" src="assets/images/user_male.png" alt="{{admin.name}}" />
      <br>

    </div>
    <div class="col-lg-9 col-md-9 col-sm-7 col-9">
      <div class="font14-700">{{admin.name}}&nbsp;&nbsp;
        <span [ngClass]="{'ACTIVE':'badge-success', 'INACTIVE':'badge-danger', 'INVITED':'badge-warning',
      'DISABLED':'badge-danger'}[adminStatus]" class="badge badge-pill txt-small">{{adminStatus | customText}}</span>
      </div>
      <div><span class="font13-600">Email: </span><span class="font13-400">{{admin.username}}</span></div>
      <div><span class="font13-600">Phone: </span><span class="font13-400">{{admin.phone}}</span></div>
      <div><span class="font13-600">Created On: </span><span
          class="font13-400">{{admin.createdDate | date:'MM/dd/yyyy hh:mm:ss a'}}</span></div>
      <div><span class="font13-600">Last Sign-In: </span><span
          class="font13-400">{{admin.lastSignedIn | date:'MM/dd/yyyy hh:mm:ss a'}}</span></div>
    </div>
    <div class="col-lg-1 col-md-1 col-sm-1 col-1 text-center">
      <small><i class="fas fa-times pointer ml-2 text-secondary" (click)="closeViewClicked()" data-toggle="tooltip"
          data-placement="right" title="Close"></i></small>
    </div>
  </div>
</div>


<div class="row mr-2 ml-2 mt-4 p-1 bg-light">
  <div class="col-12 pl-3 pr-3 pb-2 pt-1 font14-700">Security</div><br>
  <div class="col-12 pl-1">
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="verificationMode" [checked]="true" disabled>
      <label class="custom-control-label" for="verificationMode"><span class="font13-600">Verification: </span><span
          class="font13-400">2-Step Verification</span></label>
    </div>

  </div>
  <div class="col-12 pt-2 text-center" *ngIf="admin.id != loggedInUserId">
    <div class="row">
      <div *ngIf="adminStatus == 'ACTIVE'" class="col-12 p-0 text-center">
        <button class="btn btn-light" (click)="onUserDeactivate()">DEACTIVATE</button>
        <button class="btn btn-primary m-2" (click)="onResetPassword()">RESET PASSWORD</button>
      </div>
      <div *ngIf="adminStatus == 'DISABLED'" class="col-12 p-0 text-center">
        <button class="btn btn-primary" (click)="onUserActivate()">ACTIVATE</button>
      </div>
      <div *ngIf="adminStatus == 'INVITED'" class="col-12 p-0 text-center">
        <button class="btn btn-primary" (click)="onInviteResend()">RESEND INVITE</button>
      </div>
    </div>
  </div>
</div>


<div class="row mr-2 ml-2 mt-4 p-1 bg-light" *ngIf="admin && admin.roles && admin.roles.length > 0">
  <div class="col-12 pl-3 pb-2 pt-1">
    <div class="row">
      <div class="col-lg-9 col-md-8 col-sm-6 col-6 mt-2 pr-0 font14-700">
          Roles
      </div>
      <div class="col-lg-3 col-md-4 col-sm-6 col-6 pl-0 text-right">
          <button [disabled]="isSelfAccount" class="btn btn-primary" (click)="openUpdateRole()">UPDATE ROLES</button>
      </div>
    </div>
    <div class="table-responsive pt-2">
      <table class="table table-bordered table-striped">
         <thead class="thead-light">
              <tr>
                <th scope="col" width="30%">Application</th>
                <th scope="col">Role</th>
              </tr>
            </thead> 
        <tbody>
          <tr *ngFor="let role of admin.roles; let i = index">
            <td>B2B Admin Portal</td>
            <td>{{role | role_display}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


<!-- Update Role -->
<button type="button" class="btn btn-primary" id="openUpdateRole" [hidden]="true" data-toggle="modal"
  data-target="#updateRole" data-backdrop="static" data-keyboard="false">Hidden Btn</button>

<div class="modal fade" id="updateRole" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="updateRoleTitle">Update Role</h5>
        <button id="closeUpdateRole" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="resetUpdateRoleForm()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #updateRoleForm="ngForm" novalidate (ngSubmit)="updateRoleFormSubmit(updateRoleForm)">
        <div class="modal-body">
          <div class="row">
            <div class="col">

              <label>Roles</label>
              <div class="row mt-1">
                <div class="col">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" class="custom-control-input" id="roleAccAdmin" name="roleAccAdmin"
                        [checked]="isRolePresent('ROLE_ACCOUNT_ADMIN')" (change)="roleSelected('ROLE_ACCOUNT_ADMIN')">
                      <label class="custom-control-label" for="roleAccAdmin">Account Admin</label>
                    </div>
                    <div class="custom-control custom-checkbox custom-control-inline">
                      <input type="checkbox" class="custom-control-input" id="roleDeveloper" name="roleDeveloper"
                        [checked]="isRolePresent('ROLE_ACCOUNT_DEVELOPER')" (change)="roleSelected('ROLE_ACCOUNT_DEVELOPER')">
                      <label class="custom-control-label" for="roleDeveloper">Account Developer</label>
                    </div>
                  </div>
                </div>
              </div>

              <label class="mt-3">B2B Fleet Application Roles</label>
              <div class="row mt-1">
                <div class="col">
                  <div class="form-group mb-0">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" id="roleFleetOperator" name="roleFleetOperator"
                        [checked]="updateRoleModal.fleetDemoAppRole == 'ROLE_FLEET_OPERATOR'"
                        (change)="fleetDemoAppRoleClicked('ROLE_FLEET_OPERATOR')">
                      <label class="custom-control-label" for="roleFleetOperator">Fleet Operator</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" class="custom-control-input" id="roleRenter" name="roleRenter"
                        [checked]="updateRoleModal.fleetDemoAppRole == 'ROLE_RENTER'" (change)="fleetDemoAppRoleClicked('ROLE_RENTER')">
                      <label class="custom-control-label" for="roleRenter">Renter</label>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light btn-80" data-dismiss="modal" (click)="resetUpdateRoleForm()">CANCEL</button>
          <button type="submit" class="btn btn-primary btn-80">UPDATE</button>
        </div>
      </form>
    </div>
  </div>
</div>


<!-- Confirmation Model -->
<div class="modal fade" id="confirmationModel" tabindex="-1" role="dialog" aria-hidden="true">
  <!-- modal-sm -->
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="apiAccessTitle" *ngIf="currentConfirmation.heading != null">
          {{currentConfirmation.heading}}</h5>
        <button id="closeConfirmationModel" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body fix-height-20 d-flex justify-content-center">
        <div class="align-self-center text-center" *ngIf="currentConfirmation.content != null">{{currentConfirmation.content}}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light btn-80" data-dismiss="modal">CANCEL</button>
        <button type="button" class="btn btn-primary btn-80" (click)="confirm()">OK</button>
      </div>
    </div>
  </div>
</div>
<button type="button" class="btn btn-primary" id="openConfirmationModel" [hidden]="true" data-toggle="modal"
  data-target="#confirmationModel" data-backdrop="static" data-keyboard="false">Hidden Btn</button>